import { cornerClass } from '../ImageCorners/ImageCorners'
import type { CornerStyle } from '../ImageCorners/ImageCorners'
import styles from './Chairman.module.css'

type Chairman = {
  image: string
  name: string
  position: string
  cornerStyle?: CornerStyle
}

function Chairman(props: Chairman) {
  return (
    // The gradient overlay and caption sit on top of the image, so the rounding
    // has to clip the whole wrapper rather than just the <img>.
    <div className={`${styles.wrapper} ${cornerClass(props.cornerStyle, { clip: true })}`}>
      <img  className={styles.responsive} src={props.image}/>
      <div className={styles.overlay}></div>
      <div className={styles.nameAndPositioWrapper}>
        <div className={styles.innerWrapper}>
          <div className={styles.innerWrapper2}>
            <div className={styles.name}>{props.name}</div>
            <div className={styles.position}>{props.position}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Chairman }


